// @flow
import React from 'react'
import i18n from 'i18next'

import Link from '../../../Link'
import styles from './styles'
import CartIcon from '../CartIcon'

type Props = {
  color: string,
  viewport: string
}

const CartNoItems = (props: Props) => {
  function getHiperlinkStyles () {
    if (props.viewport === 'xs' || props.viewport === 'sm') {
      return styles.hyperlinkMobile
    }

    return styles.hyperlink
  }

  return (
    <Link to={i18n.t('routes.CHECKOUT_REVIEW')} style={getHiperlinkStyles()}>
      <CartIcon color={props.color} />
    </Link>
  )
}

export default CartNoItems
